"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _extend = _interopRequireDefault(require("lodash/extend"));

var _Layout = _interopRequireDefault(require("../components/Layout"));

var _ActionRoot = _interopRequireDefault(require("./ActionRoot"));

var _SessionStore = _interopRequireDefault(require("../shared/models/session/SessionStore"));

var _MessageStore = _interopRequireDefault(require("../shared/models/session/MessageStore"));

var _ContentStore = _interopRequireDefault(require("../shared/models/cms/ContentStore"));

var _RoleStore = _interopRequireDefault(require("../shared/models/session/RoleStore"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _Dispatcher = _interopRequireDefault(require("../util/Dispatcher"));

var _globals = _interopRequireDefault(require("../util/globals"));

var _upperFirst = _interopRequireDefault(require("lodash/upperFirst"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function instantiatePageStores(pageStoreClasses, props, editable, dispatcher) {
  (0, _extend.default)(props, {
    editable: editable
  });
  var infrastructureStoreClasses = {
    SessionStore: _SessionStore.default,
    MessageStore: _MessageStore.default,
    RoleStore: _RoleStore.default,
    ContentStore: _ContentStore.default
  };
  var allStoreClasses = {};
  (0, _extend.default)(allStoreClasses, infrastructureStoreClasses, pageStoreClasses);
  var pageStores = {};
  (0, _forEach.default)(allStoreClasses, function (Store, key) {
    var store = new Store(props, dispatcher);
    dispatcher.registerEvents(store);
    pageStores[(0, _upperFirst.default)((0, _camelCase.default)(key))] = store;
  });
  return pageStores;
}

var MobxView = function MobxView(View, pageStoreClasses) {
  if (typeof window !== "undefined") {
    // Hack for detecting old IE versions. Can't add conditional comments via JSX.
    var div = document.createElement("div");
    div.innerHTML = "<!--[if lte IE 9]><i></i><![endif]-->";

    if (div.getElementsByTagName("i").length == 1) {
      document.body.className += " old-ie";
    }
  } // On the client we just want to hook the view up to an existing element, so we create a window.__launcher method,
  // which will be called by a script in Layout.


  if (typeof window !== "undefined") {
    window.__launcher = function (mountId, viewProps, editable) {
      var element = document.getElementById(mountId); // For debugging only.

      Object.defineProperty && Object.defineProperty(window, "__model", {
        get: function get() {
          console.log("Don't use __model in production!");
          return viewProps;
        }
      }); // set up globals

      _globals.default.set("environment", viewProps.environment);

      var dispatcher = new _Dispatcher.default(); // instantiate page stores

      var pageStores = instantiatePageStores(pageStoreClasses, viewProps, editable, dispatcher); // Wrap the view so that it has a shared context for the dispatcher and stores to handle actions

      var ContextView = (0, _ActionRoot.default)(View, pageStores, editable, dispatcher); // render page

      _reactDom.default.hydrate( /*#__PURE__*/_react.default.createElement(ContextView, {
        editable: editable
      }), element);
    }; // Returning the view is useful for testing purposes.


    return View; // On the server we want to render the view inside of Layout.
  } else {
    return (0, _createReactClass.default)({
      render: function render() {
        var pageData = (0, _extend.default)({}, this.props.data, {
          content: this.props.content,
          editable: this.props.editable,
          asyncContentViewModel: this.props.asyncContentViewModel,
          environment: this.props.environment
        });
        var dispatcher = new _Dispatcher.default(); // instantiate page stores

        var pageStores = instantiatePageStores(pageStoreClasses, pageData, this.props.editable, dispatcher); // Wrap the view so that it has a shared context for the dispatcher and stores to handle actions

        var ContextView = (0, _ActionRoot.default)(View, pageStores, this.props.editable, dispatcher);
        return /*#__PURE__*/_react.default.createElement(_Layout.default, _extends({}, this.props, {
          mobx: true
        }), /*#__PURE__*/_react.default.createElement(ContextView, {
          editable: this.props.editable
        }));
      }
    });
  }
};

var _default = MobxView;
exports.default = _default;